import { render } from "./get-more-info.vue?vue&type=template&id=744091de"
import script from "./get-more-info.vue?vue&type=script&lang=js"
export * from "./get-more-info.vue?vue&type=script&lang=js"

import "./get-more-info.vue?vue&type=style&index=0&id=744091de&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__